import _ from 'lodash';

const sortByUnexistingProperty = sort => (sort.desc ? -1 : Infinity);

const sortProperty = (cells, sort) => _.sortBy(cells, cell => cell.vehicle[sort.sortBy]);

const sortTransportAssignedTo = (cells, sort, options) => {
  if (!options.transportAssignableSortMap) {
    return sortProperty(cells, sort);
  }

  return _.sortBy(cells, cell => {
    const sortByResult = options.transportAssignableSortMap[cell.vehicle.transport_assigned_to];
    if (!cell.vehicle.transport_assigned_to || !sortByResult) {
      return sortByUnexistingProperty(sort);
    }
    return sortByResult;
  });
};

const sortTransportOutgoingAssignedTo = (cells, sort, options) => {
  if (!options.transportAssignableSortMap) {
    return sortProperty(cells, sort);
  }

  return _.sortBy(cells, cell => {
    const sortByResult = options.transportAssignableSortMap[cell.vehicle.transport_outgoing_assigned_to];
    if (!cell.vehicle.transport_outgoing_assigned_to || !sortByResult) {
      return sortByUnexistingProperty(sort);
    }
    return sortByResult;
  });
};

const sortCounter = (cells, sort, options) =>
  _.sortBy(cells, cell => {
    if (!(options.counter_name in cell.vehicle)) {
      return sortByUnexistingProperty(sort);
    }
    return parseInt(cell.vehicle[options.counter_name], 10);
  });

const sortTransportDatum = (cells, sort) => {
  return _.sortBy(cells, cell => {
    if (!cell.vehicle.TransportDatum) {
      return sortByUnexistingProperty(sort);
    }
    return cell.vehicle.TransportDatum; // YYYYMMDD format is already sortable as string
  });
};

const columnSorterMap = {
  counter: sortCounter,
  transport_assigned_to: sortTransportAssignedTo,
  transport_outgoing_assigned_to: sortTransportOutgoingAssignedTo,
  TransportDatum: sortTransportDatum,
};

export const columnSorter = function(cells, [sort] = [], options = {}) {
  if (!sort) return cells;

  const sorter = typeof columnSorterMap[sort.sortBy] === 'function' ? columnSorterMap[sort.sortBy] : sortProperty;
  cells = sorter(cells, sort, options);

  if (sort.desc) cells.reverse();
  return cells;
};

// export const columnSorter = function (cells, sort, options = {}) {
//   if (!sort || !sort.length) return cells;
//
//   sort = sort[0];
//   let isCounter = false;
//   if (sort.sortBy === 'counter') {
//     isCounter = true;
//   }
//
//   cells = _.sortBy(cells, (cell) => {
//     if (isCounter) {
//       if (!(options.counter_name in cell.vehicle)) {
//         if (sort.desc) return -1;
//         return Infinity;
//       }
//       return parseInt(cell.vehicle[options.counter_name], 10);
//     }
//     return cell.vehicle[sort.sortBy]
//   });
//
//   if (sort.desc) cells.reverse();
//   return cells;
// };
